import React, { useEffect, useState } from 'react';
import Navigation from '../../components/Navigation/Navigation';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import Subscription from '../../components/Subscription/Subscription';
import Footer from '../../components/Footer/Footer';
import axios from 'axios';
import Subscriber from '../../components/Subscriber/Subscriber';

const PassPage = () => {
    const [subscriber, setSubscriber] = useState(false);
    const [endDate, setEndDate] = useState(null);
    const [beginDate, setBeginDate] = useState(null);

    useEffect(() => {
        const is_subscriber = async () => {
            const result = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/checkout/subscriber`,
                { withCredentials: true }
            );

            const data = result.data?.data;
            setSubscriber(Boolean(data?.is_subscriber));
            setEndDate(data?.eligibilityDate);
            setBeginDate(data?.checkout);
        };

        is_subscriber();
    }, []);

    return (
        <div>
            <Navigation />
            <BreadCrumb />
            {!subscriber && <Subscription />}
            {subscriber && <Subscriber endDate={endDate} beginDate={beginDate} />}
            <Footer />
        </div>
    );
};


export default PassPage;
